import { Component, OnInit, OnDestroy } from '@angular/core';
import { Route, ActivatedRoute, Params } from '@angular/router';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SystemSelectService } from '../../../system-select/system-select.service';
import { ToolDescriptionByTypeService, ToolService, ToolNumberService, ToolTypeService } from '../../../camtl.service';
import { Tool } from '../../../../../shared/model';
import { CgpTreeviewService } from '../../../../../shared/cgp-treeview/cgp-treeview.service';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { RouteValidationService } from "../../../../../shared/route-validation.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';



@Component({
  selector: 'app-system-layout',
  templateUrl: './system-layout.component.html',
  // styleUrls: ['./system-layout.component.scss']
})
export class SystemLayoutsComponent implements OnInit, OnDestroy {

  constructor(
    private service: ToolService,
    private toolTypeService: ToolTypeService,
    private formBuilder: FormBuilder,
    private systemSelectService: SystemSelectService,
    private routeParams: ActivatedRoute,
    private cgpTreeviewService: CgpTreeviewService,
    private toolDescriptionService: ToolDescriptionByTypeService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private routeValidationService: RouteValidationService
  ) { }

  editForm: FormGroup;
  editDataItem: Tool;
  system: any;
  toolTypeId: string;
  systemLayoutId: string;
  dataSource: any;
  selected: any;
  selectedRowId: any;
  showAssignWindow: any;
  disableAssignment: boolean = false;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit() {
    var self = this;
    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        this.system = system;
        if (this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/SystemLayout')) {
          this.cgpTreeviewService.dataSource$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(dataSource => this.dataSource = dataSource);
          this.cgpTreeviewService.selected$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(selected => this.selected = selected);
          this.cgpTreeviewService.get();
          this.cgpTreeviewService.getSelected();
          if (this.system && this.system.AllocationStatus !== null && this.system.AllocationStatus.toLowerCase().indexOf("process") !== -1) {
            this.disableAssignment = true;
          }
          else {
            this.disableAssignment = false;
          }
        }
      });
    this.systemSelectService.get();
    if (this.system) {
      this.systemSelectService.system.next(this.system);
    }

    this.routeParams.params
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params: Params) => {
        if (this.routeParams.snapshot.params["id"]) {
          this.systemLayoutId = this.routeParams.snapshot.params["id"];
        }
        else {
          this.systemLayoutId = "";
        }
      });

    this.changeTemplateService();
  }


  setUnassignedRed = (value) => {
    if (value === "N/A") {
      return 'cgp-red';
    }

    return '';
  }

  columns: any[] = [
    {
      field: "ToolDetail.ToolNumber",
      title: "Tool Number",
      width: 150
    },
    {
      field: 'ToolDescription',
      title: 'Description'
    },
    {
      field: "TotalHours",
      title: "Total Hours"
    },
    {
      field: "DesignEndDate",
      title: "Design End Date",
      template: {
        type: 'date',
        dateFormat: 'MM/dd/yyyy'
      }
    },
    {
      field: "DockDate",
      title: "Dock Date",
      template: {
        type: "date",
        dateFormat: "MM/dd/yyyy"
      }
    },
    {
      field: "Pcbom",
      title: "PCB",
      width: 80,
      template: {
        type: "customStyle",
        setClass: this.setUnassignedRed
      }
    },
    {
      field: "ToolDetail.IsIntegration",
      title: "INT",
      template: {
        type: "boolean",
        onLabel: "True",
        offLabel: "False"
      },
      width: 80
    },
    {
      field: "WireDesign",
      title: "WD",
      width: 80,
      template: {
        type: "customStyle",
        setClass: this.setUnassignedRed
      }
    },
    {
      field: "ToolDetail.IsCanceled",
      title: "CAN",
      template: {
        type: "boolean",
        onLabel: "True",
        offLabel: "False"
      },
      width: 80
    }
  ];

  assignToolsToSystemLayout = (e, dataItem, service, system, callBackInputs) => {
    this.selectedRowId = dataItem.Id;
    this.showAssignWindow = true;
  }

  saveToolAssignment(dataItems) {

    var self = this;
    for (var i = 0; i < dataItems.length; i++) {
      let di: any = dataItems[i];
      if (!di.ToolNumber) di.ToolNumber = di.ToolDetail.ToolNumber;
      this.service.save(dataItems[i], false)
        .then(function () {
          if (i === dataItems.length) {
            self.showAssignWindow = false;
            self.cgpSnackbarService.showSnackbar({
              message: i === 1 ? "Tool has been assigned" : "Tools have been assigned",
              duration: 2000
            });
            self.systemSelectService.get();
          }
        });
    }

  }

  cancelToolAssignment(e) {
    this.showAssignWindow = false;
    this.selectedRowId = undefined;
  }

  private customButtons = [
    {
      id: "assignToolsToSystemLayout",
      class: "fa fa-wrench",
      title: "Assign Tool(s)",
      callback: this.assignToolsToSystemLayout
    }
  ];

  isDisabled = (id) => {
    switch (id) {
      case "assignToolsToSystemLayout":
        return this.disableAssignment;
      default:
        return false;
    }
  }

  getById = () => {
    var self = this;
    if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/SystemLayout')) {

      this.toolTypeService.read()
        .then(function (response: any) {
          self.toolTypeId = response.filter(function (item) {
            return item.Description.toUpperCase() === "SYSTEM LAYOUT";
          })[0].Id;
        })


      return this.service.read("/" + this.systemLayoutId, true)
        .then(function (response: Tool[]) {

          for (var i = 0; i < response.length; i++) {
            response[i]["DisplayNumber"] = response[i].ToolDetail.ToolNumber;
            ;
            if (response[i].ToolDetail.DesignEndDate !== null) {
              response[i]["DesignEndDate"] = response[i].ToolDetail.DesignEndDate;
            }
            if (response[i].ToolDetail.DockDate !== null) {
              response[i]["DockDate"] = response[i].ToolDetail.DockDate;
            }

            if (response[i].ToolDetail.PcBom === null || response[i].ToolDetail.PcBom === "") {
              response[i].ToolDetail.PcBom = "N/A";
            }

            if (response[i].ToolDetail.WireDesign === null || response[i].ToolDetail.WireDesign === "") {
              response[i].ToolDetail.WireDesign = "N/A";
            }

            response[i].Pcbom = response[i].ToolDetail.PcBom;
            response[i].WireDesign = response[i].ToolDetail.WireDesign;
          }
          return response;
        })
    }
  }

  changeTemplateService() {
    if (this.systemLayoutId) {
      this.template = {
        controls: {
          add: false,
          edit: false,
          delete: false,
          excel: true,
          width: 65,
          custom: this.customButtons,
          isDisabled: this.isDisabled
        },
        columns: this.columns,
        service: this.service,
        read: this.getById,
        fileName: "system_layouts_detail.xlsx",
        displayField: "DisplayNumber"
      }
    }
  }

  getToolsForSystemByToolType = (): Promise<any> => {
    var self = this;

    if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/SystemLayout')) {

      return this.toolTypeService.read()
        .then(function (response: any) {
          self.toolTypeId = response.filter(function (item) {
            return item.Description.toUpperCase() === "SYSTEM LAYOUT";
          })[0].Id;

          return self.toolDescriptionService.read('/' + self.toolTypeId + '/toolDescription', true)
            .then(function (response) {

              return self.service.read("/" + self.system.Id + "/tooltype/" + self.toolTypeId, true)
                .then(function (response: Tool[]) {
                  for (var i = 0; i < response.length; i++) {
                    response[i]["DisplayNumber"] = response[i].ToolDetail.ToolNumber;

                    if (response[i].ToolDetail.DesignEndDate !== null) {
                      response[i]["DesignEndDate"] = response[i].ToolDetail.DesignEndDate;
                    }
                    if (response[i].ToolDetail.DockDate !== null) {
                      response[i]["DockDate"] = response[i].ToolDetail.DockDate;
                    }

                    if (response[i].ToolDetail.PcBom === null || response[i].ToolDetail.PcBom === "") {
                      response[i].ToolDetail.PcBom = "N/A";
                    }

                    if (response[i].ToolDetail.WireDesign === null || response[i].ToolDetail.WireDesign === "") {
                      response[i].ToolDetail.WireDesign = "N/A";
                    }

                    response[i].Pcbom = response[i].ToolDetail.PcBom;
                    response[i].WireDesign = response[i].ToolDetail.WireDesign;
                  }
                  return response;
                })
            });
        })
      //})
    }
  }

  template = {
    controls: {
      add: false,
      edit: false,
      delete: false,
      excel: true,
      width: 65,
      custom: this.customButtons,
      isDisabled: this.isDisabled
    },
    columns: this.columns,
    service: this.service,
    read: this.getToolsForSystemByToolType,
    fileName: "system_layouts_detail.xlsx",
    displayField: "DisplayNumber"
  }


  setModelHandler() {
    this.editDataItem = new Tool();

    if (this.system) {
      this.editDataItem.SystemId = this.system.Id;
    }
  }
}
